import styled from 'styled-components';

/* ===== Container raiz ===== */
export const StyledQRcodeList = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #fff;
  color: #111;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 80px 20px 20px 20px;

  button {
    position: fixed;
    top: 32px;
    right: 32px;
    z-index: 1000;
  }
  @media print {
    button {
      display: none;
    }
    padding: 0;
  }
`;

/* ===== Container PDF ===== */
export const PDFContainer = styled.div`
  background: #d9d9d9;
  border-radius: 8px;
  padding: 20px 250px;
  overflow: hidden;
  max-width: 100%;

  @media print {
    background: #fff;
    border-radius: 0;
    max-width: none;
    padding: 0;
  }
`;

/* ===== Container PDF Horizontal para formato 7.59x3.20 ===== */
export const PDFContainerHorizontal = styled.div`
  background: #d9d9d9;
  border-radius: 8px;
  padding: 20px 90px; /* padding reduzido para compensar a largura maior */
  overflow: hidden;
  max-width: 100%;

  @media print {
    background: #fff;
    border-radius: 0;
    max-width: none;
    padding: 0;
  }
`;

/* ===== Folha branca dentro do PDF ===== */
export const WhiteSheet = styled.div`
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  min-height: 297mm; /* altura mínima A4 */

  @media print {
    background: #fff;
    border-radius: 0;
    min-height: auto;
  }
`;

/* ===== Folha branca horizontal para formato 7.59x3.20 ===== */
export const WhiteSheetHorizontal = styled.div`
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  min-height: 210mm; /* altura A4 landscape */
  aspect-ratio: 297/210; /* proporção A4 landscape (largura/altura) */

  @media print {
    background: #fff;
    border-radius: 0;
    min-height: auto;
    aspect-ratio: none;
  }
`;

/* ===== Folha A4 com padding variável ===== */
export const A4Sheet = styled.div`
  width: 210mm;
  height: 297mm;
  background: #fff;
  box-sizing: border-box;
  page-break-after: always;
  padding: ${p => p.padding || '0'};
  &:last-child {
    page-break-after: auto;
  }
`;

/* ===== Folha A4 Landscape para etiquetas 7.59x3.20 ===== */
export const A4SheetLandscape = styled.div`
  width: 297mm;
  height: 210mm;
  background: #fff;
  box-sizing: border-box;
  page-break-after: always;
  padding: ${p => p.padding || '0'};
  &:last-child {
    page-break-after: auto;
  }
`;

/* ===== Grids ===== */
export const Grid91 = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(7, 25.5mm);
  grid-template-rows: repeat(13, 20.9mm);
  gap: 0;
  column-gap: 0.65px;
`;

export const Grid18_3x6 = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(3, 76mm);
  grid-template-rows: repeat(6, 32mm);
  gap: 0;
`;

export const Grid10_2x5 = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 362.83464567px 7.75px 362.83464567px;
  grid-template-rows: 205.98425197px 2.15px 205.98425197px 2.15px 205.98425197px 2.15px 205.98425197px 2.15px 205.98425197px;
  gap: 0;
`;

/* ===== Páginas “1 por folha” ===== */
export const Single100x50 = styled.div`
  width: 100mm;
  height: 50mm;
  padding: 2mm;
  box-sizing: border-box;
  page-break-after: always;
  &:last-child {
    page-break-after: auto;
  }
`;

export const Single60x40 = styled.div`
  width: 60mm;
  height: 40mm;
  padding: 2mm;
  box-sizing: border-box;
  page-break-after: always;
  &:last-child {
    page-break-after: auto;
  }
`;

/* ===================================================================== */
/* ==================== LAYOUT ONE (demais formatos) ==================== */
/* ===================================================================== */

export const EtiquetaOne = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  break-inside: avoid;
`;

export const ItemOne = styled.div`
  width: 100%;
  height: 100%;
  border: 0.4px dashed #b2b2b2;
  padding: 2mm;
  box-sizing: border-box;
  display: grid;
  overflow: hidden;
`;

export const MainOne = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: ${p => (p.$isSingle64 ? '25mm 9mm' : '30mm 12mm')};
  row-gap: 1mm;
`;

/* --- linha de cima: LOGO | QR | MARCA --- */
export const TopRowOne = styled.div`
  display: grid;
  grid-template-columns: ${p => (p.$isPimaco ? '52mm 1fr 5mm' : p.$isSingle105 ? '52mm 1fr 5mm' : '20mm 1fr 5mm')};
  align-items: center;
  column-gap: 1.2mm;
  height: 100%;
`;

export const CompanyOne = styled.div`
  width: 100%;
  height: 100%;
  background: #ffffff; /* placeholder quando a imagem falhar */
  border-radius: 1mm;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;

export const QRWrapOne = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const BrandOne = styled.img`
  width: 4mm;
  height: 100%;
  object-fit: contain;
  display: block;
`;

/* --- linha de baixo: NOME e TAG --- */
export const BottomRowOne = styled.div`
  display: grid;
  height: 8mm; /* ⬅ reserva fixa para textos */
  grid-template-rows: 1fr 1fr;
  align-items: center; /* centraliza verticalmente cada linha */
  text-align: left;
  overflow: hidden;
  padding-right: 1mm;
`;

export const NameOne = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: ${p => (p.$sizePt ? `${p.$sizePt}pt` : '10pt')};
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
`;

export const TagOne = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: ${p => (p.$sizePt ? `${p.$sizePt}pt` : '9pt')};
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
`;

/* ===================================================================== */
/* ============== LAYOUT TWO (2,55 × 2,09 cm – 91/A4) =================== */
/* ===================================================================== */

export const EtiquetaTwo = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  break-inside: avoid;
`;

export const ItemTwo = styled.div`
  width: 100%;
  height: 100%;
  border: 0.4px dashed #b2b2b2;
  padding: 1mm;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: 1fr 5mm; /* conteúdo | nome */
  overflow: hidden;
`;

export const MainTwo = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 1mm;
  box-sizing: border-box;
  overflow: hidden;
`;

export const NameBoxTwo = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-start; /* alinhado à esquerda */
  width: 100%;
  height: 100%;
  overflow: hidden;
  line-height: 1;
  padding: 0 2mm;
  text-align: left;
`;

/* ===================================================================== */
/* ============== ETIQUETA 7.59 × 3.20 cm – 18/A4 REFATORADA ========== */
/* ===================================================================== */

/* Container principal da etiqueta com dimensões específicas */
export const Etiqueta759x320 = styled.div`
  width: 286.8661417323px;
  height: 120.9448818898px;
  box-sizing: border-box;
  overflow: hidden;
  break-inside: avoid;
  opacity: 1;
  transform: rotate(0deg);
`;

/* Item interno da etiqueta com borda tracejada */
export const Item759x320 = styled.div`
  width: 100%;
  height: 100%;
  border: 0.86px dashed #b2b2b2;
  padding: 2mm;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: 1fr 12px; /* conteúdo principal | área do nome */
  overflow: hidden;
  position: relative;
`;

/* Área principal com logo, QR code e marca */
export const Main759x320 = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 1fr 8mm; /* linha de cima | linha de baixo */
  row-gap: 1mm;
`;

/* Linha de cima: LOGO | QR | MARCA */
export const TopRow759x320 = styled.div`
  display: grid;
  grid-template-columns: 20mm 1fr 5mm;
  align-items: center;
  column-gap: 1.2mm;
  height: 100%;
`;

/* Container do logo da empresa */
export const CompanyLogo759x320 = styled.div`
  width: 160px;
  height: 75px;
  background: #ffffff;
  border-radius: 1mm;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: absolute;
  left: 3.93px;
  top: 4.92px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;

/* Container do QR code */
export const QRCode759x320 = styled.div`
  width: 75px;
  height: 82px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  left: 180px; /* 3.93px (logo left) + 115.87998962402344px (logo width) + 5.53px (distância) */
  top: 2px;
`;

/* Container da marca */
export const Brand759x320 = styled.div`
  width: 11px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: absolute;
  right: 9.75px;
  top: 2.92px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;

/* Linha de baixo: NOME e TAG */
export const BottomRow759x320 = styled.div`
  display: grid;
  height: 30px;
  grid-template-rows: auto 12px auto;
  align-items: center;
  text-align: left;
  overflow: hidden;
  position: absolute;
  left: 3.93px;
  top: 85px; /* 2px de distância do logotipo */
  width: calc(100% - 3.93px - 9.75px); /* largura total - left - right margin */
`;

/* Texto do nome */
export const NameText759x320 = styled.span`
  font-family: 'Roboto';
  font-size: ${p => (p.$sizePt ? `${p.$sizePt}px` : '12px')};
  font-weight: 400;
  font-style: normal;
  line-height: 100%;
  letter-spacing: 0%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/* Texto da tag */
export const TagText759x320 = styled.span`
  font-family: 'Roboto';
  font-size: ${p => (p.$sizePt ? `${p.$sizePt}px` : '12px')};
  font-weight: 400;
  font-style: normal;
  line-height: 100%;
  letter-spacing: 0%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/* ===================================================================== */
/* ============== ETIQUETA 10x5-PIMACO REFATORADA ===================== */
/* ===================================================================== */

/* Container principal da etiqueta Pimaco com dimensões específicas */
export const EtiquetaPimaco = styled.div`
  width: 362.83464567px;
  height: 205.98425197px;
  box-sizing: border-box;
  overflow: hidden;
  break-inside: avoid;
`;

/* Item interno da etiqueta com borda tracejada personalizada */
export const ItemPimaco = styled.div`
  width: 100%;
  height: 100%;
  padding: 2mm;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: 1fr 12px; /* conteúdo principal | área do nome */
  overflow: hidden;
  position: relative;
`;

/* Área principal com logo, QR code e marca */
export const MainPimaco = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 1fr 8mm; /* linha de cima | linha de baixo */
  row-gap: 1mm;
`;

/* Linha de cima: LOGO | QR | MARCA */
export const TopRowPimaco = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

/* Container do logo da empresa */
export const CompanyLogoPimaco = styled.div`
  width: 142px;
  height: 110px;
  background: #ffffff;
  border-radius: 1mm;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 8.95px;
  top: 14.04px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;

/* Container do QR code */
export const QRCodePimaco = styled.div`
  width: 110px;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  left: 185px; /* 8.95px (logo left) + 141.22px (logo width) + 3.68px (distância) */
  top: 14.04px;
`;

/* Container da marca */
export const BrandPimaco = styled.img`
  width: 10mm;
  height: 110px;
  object-fit: contain;
  display: block;
  position: absolute;
  right: 0.88px;
  top: 14.04px;
`;

/* Linha de baixo: NOME e TAG */
export const BottomRowPimaco = styled.div`
  display: grid;
  height: 10mm;
  grid-template-rows: 1fr 1fr;
  align-items: center;
  text-align: left;
  overflow: hidden;
  position: absolute;
  left: 15px;
  top: 140px; /* 14.04px (logo top) + 85.09px (logo height) + 14px (distância) */
  width: calc(100% - 15px - 0.88px); /* largura total - left - right margin */
`;

/* Texto do nome */
export const NameTextPimaco = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: ${p => (p.$sizePt ? `${p.$sizePt}pt` : '10pt')};
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
`;

/* Texto da tag */
export const TagTextPimaco = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: ${p => (p.$sizePt ? `${p.$sizePt}pt` : '9pt')};
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
`;

/* ===================================================================== */
/* ============== ETIQUETA 10x5-SINGLE (ROLO) REFATORADA =============== */
/* ===================================================================== */

/* Container principal da etiqueta de rolo com dimensões específicas */
export const EtiquetaRoll = styled.div`
  width: 100mm;
  height: 50mm;
  box-sizing: border-box;
  overflow: hidden;
  break-inside: avoid;
`;

/* Item interno da etiqueta sem borda */
export const ItemRoll = styled.div`
  width: 100%;
  height: 100%;
  padding: 2mm;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: 1fr 8mm; /* conteúdo principal | área do nome */
  overflow: hidden;
  position: relative;
`;

/* Área principal com logo, QR code e marca */
export const MainRoll = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 1fr 6mm; /* linha de cima | linha de baixo */
  row-gap: 1mm;
`;

/* Linha de cima: LOGO | QR | MARCA */
export const TopRowRoll = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

/* Container do logo da empresa */
export const CompanyLogoRoll = styled.div`
  width: 50mm;
  height: 30mm;
  background: #ffffff;
  border-radius: 1mm;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 2mm;
  top: 2mm;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;

/* Container do QR code */
export const QRCodeRoll = styled.div`
  width: 30mm;
  height: 30mm;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  left: 54mm; /* 2mm (logo left) + 50mm (logo width) + 2mm (distância) */
  top: 2mm;
`;

/* Container da marca */
export const BrandRoll = styled.img`
  width: 4mm;
  height: 29mm;
  object-fit: fill;
  display: block;
  position: absolute;
  right: 5mm;
  top: 2mm;
`;

/* Linha de baixo: NOME e TAG */
export const BottomRowRoll = styled.div`
  display: grid;
  height: 6mm;
  grid-template-rows: 1fr 1fr;
  align-items: center;
  text-align: left;
  overflow: hidden;
  position: absolute;
  left: 4mm;
  top: 36mm; /* 2mm (logo top) + 30mm (logo height) + 4mm (distância) */
  width: calc(100% - 8mm); /* largura total - left - right margin */
`;

/* Texto do nome */
export const NameTextRoll = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: ${p => (p.$sizePt ? `${p.$sizePt}pt` : '8pt')};
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
`;

/* Texto da tag */
export const TagTextRoll = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: ${p => (p.$sizePt ? `${p.$sizePt}pt` : '7pt')};
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
`;

/* ===================================================================== */
/* ============== ETIQUETA 6x4-SINGLE (ROLO) REFATORADA =============== */
/* ===================================================================== */

/* Container principal da etiqueta de rolo 6x4 com dimensões específicas */
export const EtiquetaRoll64 = styled.div`
  width: 60mm;
  height: 40mm;
  box-sizing: border-box;
  overflow: hidden;
  break-inside: avoid;
`;

/* Item interno da etiqueta sem borda */
export const ItemRoll64 = styled.div`
  width: 100%;
  height: 100%;
  padding: 1.5mm;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: 1fr 6mm; /* conteúdo principal | área do nome */
  overflow: hidden;
  position: relative;
`;

/* Área principal com logo, QR code e marca */
export const MainRoll64 = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 1fr 5mm; /* linha de cima | linha de baixo */
  row-gap: 1mm;
`;

/* Linha de cima: LOGO | QR | MARCA */
export const TopRowRoll64 = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

/* Container do logo da empresa */
export const CompanyLogoRoll64 = styled.div`
  width: 30mm;
  height: 20mm;
  background: #ffffff;
  border-radius: 1mm;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0mm;
  top: 1.5mm;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;

/* Container do QR code */
export const QRCodeRoll64 = styled.div`
  width: 20mm;
  height: 20mm;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  left: 31mm; /* 1.5mm (logo left) + 30mm (logo width) + 1mm (distância) */
  top: 1.5mm;
`;

/* Container da marca */
export const BrandRoll64 = styled.img`
  width: 3mm;
  height: 20mm;
  object-fit: contain;
  display: block;
  position: absolute;
  right: 1.5mm;
  top: 1.5mm;
`;

/* Linha de baixo: NOME e TAG */
export const BottomRowRoll64 = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  align-items: center;
  text-align: left;
  overflow: hidden;
  position: absolute;
  left: 1.5mm;
  top: 24mm; /* 1.5mm (logo top) + 20mm (logo height) + 2.5mm (distância) */
  width: calc(100% - 3mm); /* largura total - left - right margin */
`;

/* Texto do nome */
export const NameTextRoll64 = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: ${p => (p.$sizePt ? `${p.$sizePt}pt` : '7pt')};
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
`;

/* Texto da tag */
export const TagTextRoll64 = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: ${p => (p.$sizePt ? `${p.$sizePt}pt` : '6pt')};
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
`;
